import styled from 'styled-components';

export const ValidationMessage = styled.div<{
  type: 'error' | 'warning';
  children?: React.ReactNode;
}>`
  color: ${(props) => (props.type === 'error' ? '#ff4d4f' : '#faad14')};
  font-size: 12px;
  margin-top: 8px;
  height: 20px;
`;

export const ModalContent = styled.div`
  width: 100%;
`;

export const ModalHeader = styled.div`
  /* just keep */
`;

export const ModalTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;

export const ModalDescription = styled.div`
  color: rgb(0 0 0 / 88%);
  line-height: 20px;
  margin: 16px 0;
`;

export const CriticalEventSelectionSection = styled.div`
  /* just keep */
`;

export const CriticalEventSelectionLabel = styled.div`
  margin-bottom: 16px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;
